// Agrupa reservas consecutivas (misma sala_id + fecha, hora_fin === próxima.hora_inicio).
// Devuelve grupos ordenados por fecha + hora_inicio ascendente.
export function agruparReservas(items) {
    const ordenadas = [...items].sort((a, b) =>
        a.fecha === b.fecha
            ? a.hora_inicio.localeCompare(b.hora_inicio)
            : a.fecha.localeCompare(b.fecha)
    );
    const grupos = [];
    for (const r of ordenadas) {
        const last = grupos[grupos.length - 1];
        if (
            last &&
            last.sala_id === r.sala_id &&
            last.fecha === r.fecha &&
            last.hora_fin === r.hora_inicio
        ) {
            last.reservas.push(r);
            last.hora_fin = r.hora_fin;
        } else {
            grupos.push({
                key: r.reserva_id,
                sala_id: r.sala_id,
                fecha: r.fecha,
                hora_inicio: r.hora_inicio,
                hora_fin: r.hora_fin,
                motivo: r.motivo,
                reservas: [r],
            });
        }
    }
    return grupos;
}
